<template>
    <div class="pandoraMenuitemv2">
        <a v-if="props.href" :href="props.href" role="button" :aria-label="props.text ?? ''"
            :class="[titleactive == props.text && 'isActive']">{{ props.text }}</a>
        <a v-else role="menu" :aria-label="props.text ?? ''" :class="[titleactive == props.text && 'isActive']">{{
            props.text }} <img height="auto" width="auto" v-if="props?.submenu" class="imgStylesv2" :src="iconLineV"
                alt="icono" aria-label="Ícono de ayuda visual" /></a>
        <slot></slot>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import '../../../assets/css/config.css'
import iconLineV from '../../../assets/iconLineV.png';

const props = defineProps({
    text: {
        type: String,
        default: ''
    },
    href: {
        type: String,
        default: ''
    },
    titleactive: {
        type: String,
        default: ''
    },
    submenu: {
        default: ''
    }
});
</script>

<style scoped>
.pandoraMenuitemv2 {
    position: relative;
    display: block;
    opacity: 0;
    cursor: pointer;
    text-align: left;
}

.imgStylesv2 {
    margin-bottom: -4px;
    padding-left: 10px;
    float: right;
}

.menuContainerv2>.pandoraMenuv2>.pandoraMenuitemv2 {
    pointer-events: all;
    opacity: 1;
}

.menuContainerv2 a {
    background: #FFF;
    color: #6B6C7E;
    text-decoration: none;
    width: inherit;
    transition: background 0.5s, color 0.5s, transform 0.5s;
    padding: 12.5px 17px;
    box-sizing: border-box;
    position: relative;
    font-family: Rubik, sans-serif;
    font-size: 13px;
}

.pandoraMenuv2 .pandoraMenuitemv2 a {
    white-space: nowrap;
    display: block;
    font-family: Rubik-semibold, sans-serif;
}

.menuContainerv2>.pandoraMenuv2>.pandoraMenuitemv2>a {
    text-decoration: none;
}

.isActive {
    border-bottom: 4px solid #007A5E !important;
    color: #272833 !important;
}

.menuContainerv2 {
    margin-top: 40px;
    margin-left: 40px;
}

.menuContainerv2 a:hover:before {
    content: '';
    padding-left: 30px;
    top: 0;
    left: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
}

.pandoraMenuitemv2>.pandoraMenuv2>.pandoraMenuitemv2>.pandoraMenuv2>.pandoraMenuitemv2 {
    transition: transform 0.1s, opacity 0.1s;
    transform: translateX(195px) translateY(0%);
    opacity: 0;
}

.menuContainerv2>.pandoraMenuv2>.pandoraMenuitemv2>.pandoraMenuv2>.pandoraMenuitemv2 {
    transition: transform 0.3s, opacity 0.3s;
    transform: translateY(150%);
    opacity: 0;
}

.menuContainerv2>.pandoraMenuv2>.pandoraMenuitemv2:hover>.pandoraMenuv2>.pandoraMenuitemv2,
.menuContainerv2>.pandoraMenuv2>.pandoraMenuitemv2.hover>.pandoraMenuv2>.pandoraMenuitemv2 {
    transform: translateY(0%);
    opacity: 1;
}

.pandoraMenuitemv2>.pandoraMenuv2>.pandoraMenuitemv2:hover>.pandoraMenuv2>.pandoraMenuitemv2,
.pandoraMenuitemv2>.pandoraMenuv2>.pandoraMenuitemv2.hover>.pandoraMenuv2>.pandoraMenuitemv2 {
    transform: translateX(0) translateY(0%);
    opacity: 1;
}
</style>